module.exports = __webpack_public_path__ + "c8cd232189585208a4c7a0990f421685.png";